import axios, { AxiosResponse } from 'axios';
import {apiService} from "./api.service";
import {convertToPageable, extractData, handleResponse, downloadFile, handleApiException, downloadFileWithPresignedUrl} from "../helpers/apiResponseHelper";
import { IFuelInvoiceRequest } from 'models/fuel-invoice';

async function getDocumentRows(customerId: number, pageRequest: any) {
    return axios.get(apiService.getApiUrl() + '/document-rows/' + customerId,
        {
            params: pageRequest,
        }).then(handleResponse).then(convertToPageable).catch(handleApiException);
}
async function getDocumentRowsSum(customerId: number) {
    return axios.get(apiService.getApiUrl() + '/document-rows/sums/' + customerId)
        .then(handleResponse).then(extractData).catch(handleApiException);
}

async function getDocumentFile(remoteDocumentId: number) : Promise<AxiosResponse<string>>{
    return axios.get(`${apiService.getApiUrl()}/documents/pdf?documentRemoteId=${remoteDocumentId}`)
        .then(handleResponse).catch(handleApiException);
}

async function getDocumentZipFile(remoteDocumentIds: number[]) : Promise<Blob>{
    const url = apiService.getApiUrl() + '/documents/zip?documentIds=' + remoteDocumentIds;
    return axios.get(url,
        {
            responseType: 'blob'
        }).then(handleResponse).catch(handleApiException);
}

async function getDocumentFileWithDownload(remoteDocumentId: number) {
    return getDocumentFile(remoteDocumentId).then(res => downloadFileWithPresignedUrl(res.data));
}

async function getDocumentZipFileWithDownload(remoteDocumentIds: number[], name: string) {
    const url = apiService.getApiUrl() + '/documents/zip?documentIds=' + remoteDocumentIds;

    return getDocumentZipFile(remoteDocumentIds).then(res => downloadFile(name + '.zip', res, url));
}

async function getInvoices(customerId: number, pageRequest: IFuelInvoiceRequest) {
    return axios.get(apiService.getApiUrl() + '/documents/' + customerId,
        {
            params: pageRequest
        }).then(handleResponse).then(convertToPageable).catch(handleApiException);
}

async function getDocumentsVehicleNumbers(customerId: number) {
    return axios.get(apiService.getApiUrl() + '/documents/' + customerId + '/vehicle-numbers')
        .then(handleResponse).then(extractData).catch(handleApiException);
}

const DocumentService = {
    getDocumentRows,
    getDocumentRowsSum,
    getDocumentFile,
    getDocumentFileWithDownload,
    getDocumentZipFileWithDownload,
    getInvoices,
    getDocumentsVehicleNumbers
};

export default DocumentService;
